import { useFormik } from "formik";
import React from "react";
import * as yup from "yup";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Box,
} from "@mui/material";

import { IoCloseOutline } from "react-icons/io5";
import { DateTimePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

function EditSessionDialog({ open = true, onClose, onChange, session }) {
  const validationSchema = yup.object({
    time: yup
      .date()
      .required()
      .label("Session Time")
      .typeError("Session Time should be a valid Date and Time"),
  });
  const formik = useFormik({
    initialValues: session,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      onChange(values);
      onClose();
    },
  });

  return (
    formik.values && (
      <form>
        <Dialog
          open={open}
          keepMounted
          onClose={onClose}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>
            <Box display="flex" alignItems="center">
              <Box flexGrow={1}>
                <h2 className="font-extrabold text-lg">Edit Session</h2>
              </Box>
              <Box>
                <IconButton onClick={onClose}>
                  <IoCloseOutline />
                </IconButton>
              </Box>
            </Box>
          </DialogTitle>
          <DialogContent>
            <div className="my-4">
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DateTimePicker
                  label="Time For First Session"
                  value={formik.values.time}
                  disablePast
                  name="time"
                  onChange={(m) => {
                    if (m) {
                      formik.setFieldValue("time", m.format());
                      formik.setFieldValue("endTime", m.add(session.duration, "minutes").format());
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      error={formik.touched.time && Boolean(formik.errors.time)}
                      helperText={formik.touched.time && formik.errors.time}
                    />
                  )}
                />
              </LocalizationProvider>
            </div>
          </DialogContent>
          <DialogActions>
            <Button type="submit" onClick={formik.handleSubmit}>
              Done
            </Button>
          </DialogActions>
        </Dialog>
      </form>
    )
  );
}

export default EditSessionDialog;
